/* eslint-disable */
<template>
  <canvas ref="videoViewCanvas" class="video-view-canvas" :width="width" :height="height">
    <image-pre-loader
      v-for="(data, index) in preLoaderDataComp"
      :key="index"
      ref="preLoader"
      track-by="index"
      :index="index"
      :img-sequence-src="data.filePath"
      :load-pattern="data.loadPattern"
      :progress-interval="data.progressInterval"
      :img-sequence-src-digits="data.imgSequenceSrcDigits"
      :image-Loader-Threads="data.imageLoaderThreads"
      :frame-count="data.frameCount"
      :first-frame="data.firstFrame"
      :pre-load-amount="data.preLoadAmount"
      :load-initial-position="curLoadedPosition"
      @progress="progress"
      @initial-load-finished="initialFrameLoaded"
      @pre-load-finished="preLoadFinished"
    ></image-pre-loader>
  </canvas>
</template>

<script>
/* eslint-disable */
import ImagePreLoader from './ImagePreLoader.vue';
import { defineComponent } from '@vue/composition-api';
// import ResizeSensor from 'css-element-queries/src/ResizeSensor'
import Vue from 'vue';
import { isNum, clamp } from './ivvHelperFunctions.js';

Number.prototype.clamp = clamp;

export default defineComponent({
  components: {
    ImagePreLoader,
  },
  props: {
    /**
     * the time position of the video
     */
    position: { type: Number, default: 0 },
    /**
     * type of the position, this can either be 'frames' or 'percent' percentage value,
     * if it is 'frames' all image pre loader have to have the same amount of frames
     * if it is 'frames' @position represents the current frame, if it is 'percent' @position is between 0 and 1
     */
    positionType: { type: String, default: 'percent' },
    /**
     * width in pixels of the video in full resolution(the highest resolution image sequence)
     */
    width: { type: Number, required: true },
    /**
     * height in pixels of the video in full resolution(the highest resolution image sequence)
     */
    height: { type: Number, required: true },
    /**
     * The preloader data is an object, that contains two values, called preLoaderData and defaultData.
     * preLoaderData is an Array of options for the Image Preloader,
     * and defaultData are the missing values, if some options are not declared in the Array preLoaderData
     */
    preLoaderData: { type: Object, required: true },
    /**
     * loads this amount(from 0.0-1.0), it reacts if it will be changed, if it was initially 0.1 and everything is loaded,
     * and it will be changed to e.g. 0.5, the rest will be loaded automatically.
     * it should be adjusted with @preLoaderData, and if it is below the "minProgress" of the next image sequence, only this image sequence will be taken for loading
     */
    preLoadAmount: { type: Number, default: 0.0 },
    /**
     * if negative, no high resolution will be loaded, otherwise it describes a still timeout (in milliseconds) when to load a high resolution image (the preloader with the biggest minimum download speed).
     * the timeout gets resetted after a movement occurs
     * after the timeout the high resolution image gets faded in after @highResolutionFadeInTime milliseconds
     */
    highResolutionTimeout: { type: Number, default: -1 },
    /**
     * the time amount (in milliseconds) while the fade in occurs (linear fade in)
     */
    highResolutionFadeInTime: { type: Number, default: 1000 },
  },
  data() {
    return {
      _highResolutionTimeout: null,
      highResStartFadeTime: null,
      highResLoaded: false,
      firstFrameLoaded: false,
      curLoadedPosition: 0,
      curPreLoaderIndex: 0,
      newPreLoaderIndex: 0,
      highResolutionPreLoaderIndex: 0,
      newPreLoaderStartedLoading: false,
      videoViewHasChanged: true,
      frameCount: 1,
      preLoadAmountData: [],
    };
  },
  computed: {
    preLoaderDataComp: {
      get() {
        var retVal = [];
        this.preLoaderData.preLoaderData.forEach((e, i, a) => {
          var curData = {};
          this.preLoaderData.defaultData;
          curData.progressInterval = e.progressInterval != undefined ? e.progressInterval : this.preLoaderData.defaultData.progressInterval;
          curData.loadPattern = e.loadPattern != undefined ? e.loadPattern : this.preLoaderData.defaultData.loadPattern;
          curData.filePath = e.filePath != undefined ? e.filePath : this.preLoaderData.defaultData.filePath;
          curData.imgSequenceSrcDigits = e.imgSequenceSrcDigits != undefined ? e.imgSequenceSrcDigits : this.preLoaderData.defaultData.imgSequenceSrcDigits;
          curData.imageLoaderThreads = e.imageLoaderThreads != undefined ? e.imageLoaderThreads : this.preLoaderData.defaultData.imageLoaderThreads;
          curData.frameCount = e.frameCount != undefined ? e.frameCount : this.preLoaderData.defaultData.frameCount;
          curData.firstFrame = e.firstFrame != undefined ? e.firstFrame : this.preLoaderData.defaultData.firstFrame;
          curData.preLoadAmount = isNum(this.preLoadAmountData[i])
            ? this.preLoadAmountData[i]
            : e.preLoadAmount != undefined
            ? e.preLoadAmount
            : this.preLoaderData.defaultData.preLoadAmount;
          retVal.push(curData);
        });
        return retVal;
      },
    },
  },
  methods: {
    animloop() {
      if (this.videoViewHasChanged) {
        this.videoViewHasChanged = false;
        var ctx = this.$refs.videoViewCanvas.getContext('2d');
        var img;
        if (this.positionType === 'frames') img = this.$refs.preLoader[this.curPreLoaderIndex].getNearestImageNorm(this.position / this.frameCount);
        else img = this.$refs.preLoader[this.curPreLoaderIndex].getNearestImageNorm(this.position);
        if (!!img) {
          ctx.clearRect(0, 0, this.width, this.height);
          ctx.drawImage(img.img, 0, 0, this.width, this.height);
          this.curLoadedPosition = img.position;
        }
        if (this.highResLoaded && this.highResolutionTimeout > 0) {
          var highimg;
          if (this.positionType === 'frames')
            highimg = this.$refs.preLoader[this.highResolutionPreLoaderIndex].getNearestImageNorm(this.position / this.frameCount);
          else highimg = this.$refs.preLoader[this.highResolutionPreLoaderIndex].getNearestImageNorm(this.position);
          if (highimg && highimg.index == img.index) {
            var alphaFade = 0;
            alphaFade = ((Date.now() - this.highResStartFadeTime) / this.highResolutionFadeInTime).clamp(0, 1.0);

            if (alphaFade < 1.0) {
              this.videoViewHasChanged = true;
              window.requestAnimationFrame(this.animloop);
            }
            ctx.globalAlpha = alphaFade;
            if (!!highimg) ctx.drawImage(highimg.img, 0, 0, this.width, this.height);
            ctx.globalAlpha = 1.0;
          }
        }
        if (!this.highResLoaded && this.highResolutionTimeout > 0) {
          clearTimeout(this._highResolutionTimeout);
          this._highResolutionTimeout = setTimeout(
            this.$refs.preLoader[this.highResolutionPreLoaderIndex].startLoadingInitialFrame,
            this.highResolutionTimeout
          );
        }
      }
    },
    checkForNewPreloader(downloadSpeed, currentProgress) {
      if (!this.newPreLoaderStartedLoading) {
        var curMaxDownloadSpeed = 0;
        var curIndex = this.curPreLoaderIndex;
        for (var i = 0; i < this.preLoaderData.preLoaderData.length; ++i) {
          if (
            this.preLoaderData.preLoaderData[i].minProgress <= currentProgress &&
            this.preLoaderData.preLoaderData[i].minDownloadSpeed <= downloadSpeed &&
            this.preLoaderData.preLoaderData[i].minDownloadSpeed > curMaxDownloadSpeed &&
            this.preLoaderData.preLoaderData[i].minDownloadSpeed > this.preLoaderData.preLoaderData[this.curPreLoaderIndex].minDownloadSpeed
          ) {
            curMaxDownloadSpeed = this.preLoaderData.preLoaderData[i].minDownloadSpeed;
            curIndex = i;
          }
        }
        if (curIndex != this.curPreLoaderIndex) {
          // stop loading of the old preloader
          Vue.set(this.preLoadAmountData, this.curPreLoaderIndex, 0);
          // start loading of the new preloader
          Vue.set(this.preLoadAmountData, curIndex, this.preLoadAmount);
          this.newPreLoaderStartedLoading = true;
          this.newPreLoaderIndex = curIndex;
        }
      }
    },
    preLoadFinished(index) {},
    progress(msg) {
      if (msg.index != this.curPreLoaderIndex && msg.progress >= this.preLoaderData.preLoaderData[msg.index].minLoad) {
        this.$refs.preLoader[this.curPreLoaderIndex].reset();
        this.curPreLoaderIndex = msg.index;
        this.newPreLoaderStartedLoading = false;
      }
      this.checkForNewPreloader(msg.downloadSpeed, msg.progress);
    },
    initialFrameLoaded(index) {
      if (this.highResolutionTimeout > 0) {
        if (!this.firstFrameLoaded && !this.highResLoaded) {
          this.firstFrameLoaded = true;
          this.videoViewHasChanged = true;
        }
        if (index == this.highResolutionPreLoaderIndex) {
          this.videoViewHasChanged = true;
          this.highResLoaded = true;
          this.highResStartFadeTime = Date.now();
        }
      } else this.videoViewHasChanged = true;
      window.requestAnimationFrame(this.animloop);
    },
    checkFrameCount() {
      if (this.positionType === 'frames') {
        this.frameCount = null;
        if (this.preLoaderData.defaultData && typeof this.preLoaderData.defaultData.frameCount === 'number')
          this.frameCount = this.preLoaderData.defaultData.frameCount;
        this.preLoaderData.preLoaderData.forEach((e, i, a) => {
          if (this.frameCount && e.frameCount) {
            if (this.frameCount != e.frameCount) throw 'frameCount has to be the same in every preloader';
          } else if (e.frameCount) this.frameCount = e.frameCount;
        });
      }
    },
  },
  watch: {
    preLoadAmount: function (newVal, oldVal) {
      if (this.newPreLoaderStartedLoading) Vue.set(this.preLoadAmountData, this.newPreLoaderIndex, newVal);
      else Vue.set(this.preLoadAmountData, this.curPreLoaderIndex, newVal);
    },
    width: function () {
      this.videoViewHasChanged = true;
      window.requestAnimationFrame(this.animloop);
    },
    height: function () {
      this.videoViewHasChanged = true;
      window.requestAnimationFrame(this.animloop);
    },
    position: function () {
      this.highResLoaded = false;
      this.videoViewHasChanged = true;
      window.requestAnimationFrame(this.animloop);
    },
    preloaderData: 'checkFrameCount',
  },
  created() {
    for (var i = 0; i < this.preLoaderData.preLoaderData.length; ++i) {
      if (this.preLoaderData.preLoaderData[i].minProgress === 0 && this.preLoaderData.preLoaderData[i].minDownloadSpeed === 0) {
        this.preLoadAmountData.push(this.preLoaderData.preLoaderData[i].preLoadAmount);
        this.curPreLoaderIndex = i;
        if (this.preLoadAmount > this.preLoadAmountData[i]) this.preLoadAmountData[i] = this.preLoadAmount;
        break;
      }
    }
    for (var i = 0; i < this.preLoaderData.preLoaderData.length; ++i) {
      if (this.preLoaderData.preLoaderData[i].minDownloadSpeed < 0) {
        this.highResolutionPreLoaderIndex = i;
        break;
      }
    }
  },
  mounted() {
    this.checkFrameCount();
    window.requestAnimationFrame(this.animloop);
  },
});
</script>
